import { z } from "zod";
import { PropertySchema } from "../../../services/properties/response/ShowPropertiesResponse";

const ResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: PropertySchema,
});

export { ResponseSchema, PropertySchema };
export type PropertyUpdateResponseType = z.infer<typeof ResponseSchema>;